import { Provider } from '@angular/core';
import { HttpErrorHandler } from '@spartacus/core';
import { CustomBadRequestHandler } from './bad-request/bad-request.handler';
import { CustomBadCartRequestHandler } from './bad-request/custom-bad-cart-request.handler';
import { CustomBadVoucherRequestHandler } from './bad-request/custom-bad-voucher-request.handler';
import { CustomInternalServerErrorHandler } from './internal-server/internal-server.handler';

export const errorHandlers: Provider[] = [
  {
    provide: HttpErrorHandler,
    useExisting: CustomBadRequestHandler,
    multi: true,
  },
  {
    provide: HttpErrorHandler,
    useExisting: CustomInternalServerErrorHandler,
    multi: true,
  },
  {
    provide: HttpErrorHandler,
    useClass: CustomBadCartRequestHandler,
    multi: true,
  },
  {
    provide: HttpErrorHandler,
    useClass: CustomBadVoucherRequestHandler,
    multi: true,
  },
];
